import { FormatterService } from "@/domain/services";
import { formatters } from "../utils/formatters";

export class PhoneFormatter implements FormatterService {
  searchValue = formatters.celphone.searchValue;
  replaceValue = formatters.celphone.replaceValue;

  format(value: string): string {
    return value.replace(this.searchValue, this.replaceValue).trim();
  }

  toPattern(value: string, customPattern: string): string {
    let newString = "";
    let stringIndex = 0;

    const pattern = this.replacePhoneNumberToHash(customPattern);

    const patternCount = pattern.length;
    for (var i = 0; i < patternCount; i++) {
      if (value[stringIndex]) {
        if (pattern[i] === "#") {
          newString = `${newString}${value[stringIndex]}`;
          stringIndex++;
        } else {
          newString = `${newString}${pattern[i]}`;
        }
      }
    }

    return newString;
  }

  private replacePhoneNumberToHash = (text: string) => {
    let res = "";

    if (text) {
      for (let i = 0; i < text.length; i++) {
        if (text[i] === "9") {
          res += "#";
        } else {
          res += text[i];
        }
      }
    }

    return res;
  };
}
